import React from 'react'
import { Button, Flex, Space } from 'antd'
import { LogoutOutlined, LoginOutlined } from '@ant-design/icons'
import { UserAvatar } from 'components/Avatar/Avatar'
import { useOidcAuth } from 'hooks/useOidcAuth'
import { useFeatureFlags } from 'hooks/useFeatureFlags'
import { isNil } from 'ramda'
import { ErrorNotification } from 'services/helpers/helpers'
import { Link } from 'react-router-dom'
import { GoogleLogin } from 'react-oauth-google'
import { getUser } from '../../services/StatusDbApi'

export const AuthButton = ({
  user,
  setGoogleToken,
  setGoogleUser,
  googleLogout,
  setIsAuthLoading,
}) => {
  const auth = useOidcAuth()
  const { IS_HOSPITAL } = useFeatureFlags()

  if (auth.isAuthenticated) {
    return (
      <Flex gap="large" align="center">
        <Link to="/account">
          <UserAvatar user={auth.user} />
        </Link>
        <Button
          type="text"
          icon={<LogoutOutlined style={{ fontSize: '16px' }} />}
          iconPosition={'start'}
          onClick={() => auth.logout()}
          style={{ color: '#fff', fontSize: '16px' }}
        >
          Log out
        </Button>
      </Flex>
    )
  }

  return IS_HOSPITAL ? (
    <Button
      type="text"
      icon={<LoginOutlined style={{ fontSize: '16px' }} />}
      iconPosition={'start'}
      onClick={() => auth.login()}
      style={{ color: '#fff', fontSize: '16px' }}
    >
      Log in
    </Button>
  ) : isNil(user) ? (
    <div>
      <GoogleLogin
        size="medium"
        onSuccess={(response) => {
          setIsAuthLoading(true)
          if ('credential' in response) {
            setGoogleToken(response.credential)
            getUser(response.credential as string)
              .then(({ user }) => {
                setGoogleUser(user)
                setIsAuthLoading(false)
              })
              .catch((error) => {
                if (error.response.status === 403) {
                  ErrorNotification(
                    'Access Denied',
                    'You do not have permission to login with this account.'
                  )
                  setIsAuthLoading(false)
                } else {
                  ErrorNotification(
                    'Could not login',
                    'Something went wrong. Please try again later.'
                  )
                  setIsAuthLoading(false)
                }
              })
          }
        }}
        onError={() => console.log('Login Failed')}
        useOneTap
        auto_select
        /* use_fedcm_for_prompt */
      />
    </div>
  ) : (
    <div>
      <Space size="large">
        <Link to="/account">
          <UserAvatar user={user} />
        </Link>
        <Link to="/">
          <Button
            type="text"
            icon={<LogoutOutlined style={{ fontSize: '16px' }} />}
            iconPosition={'start'}
            onClick={googleLogout}
            style={{ color: '#fff', fontSize: '16px' }}
          >
            Log out
          </Button>
        </Link>
      </Space>
    </div>
  )
}
